import { Header, Footer } from "./Pricing";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-stone-50">
      <Header />
      <main className="max-w-3xl mx-auto px-6 py-16 prose prose-stone">
        <div className="text-xs uppercase tracking-[0.25em] font-semibold text-emerald-700">Legal</div>
        <h1 className="mt-3 font-display text-4xl font-medium text-stone-900">Privacy Policy</h1>
        <p className="text-sm text-stone-500">Last updated: February 19, 2026</p>

        <p>ChildCheckOh ("we", "us") is committed to protecting the privacy of childcare center owners, directors, staff, parents, and children whose data flows through our Service.</p>

        <h2>1. Information we collect</h2>
        <ul>
          <li><b>Account info:</b> name, email, phone, role, center name, business address</li>
          <li><b>Child records:</b> name, DOB, parent contact info, enrollment forms, medical / immunization records, attendance events</li>
          <li><b>Staff records:</b> name, credentials, training certificates, background-check status, payroll-related identifiers</li>
          <li><b>Operational data:</b> attendance check-in/out events, lesson plans, compliance scans, messages</li>
          <li><b>Payment info:</b> handled exclusively by PayPal — we never see or store full credit-card numbers or PayPal login credentials</li>
          <li><b>Usage data:</b> IP address, browser type, pages viewed, timestamps (basic web analytics)</li>
        </ul>

        <h2>2. How we use it</h2>
        <ul>
          <li>To operate, maintain, and improve the Service</li>
          <li>To send important notices (compliance reminders, payment receipts, password resets)</li>
          <li>To respond to support requests</li>
          <li>To detect and prevent fraud or abuse</li>
        </ul>
        <p><b>We do NOT sell, rent, or share your data with advertisers.</b></p>

        <h2>3. Who we share it with</h2>
        <p>We share data only with vetted subprocessors necessary to run the Service:</p>
        <ul>
          <li><b>PayPal</b> — payment processing for monthly subscriptions</li>
          <li><b>SendGrid / Gmail</b> — transactional email delivery</li>
          <li><b>MongoDB Atlas / Emergent hosting</b> — secure cloud storage of your data</li>
          <li><b>OpenAI / Anthropic / Google</b> — AI features (only the specific text you submit; AI providers do not retain or train on it under our agreement)</li>
        </ul>
        <p>We also disclose information if required by law (subpoena, court order) or to protect the safety of a child.</p>

        <h2>4. How we protect it</h2>
        <ul>
          <li>TLS encryption in transit (HTTPS everywhere)</li>
          <li>Vault passcodes (separate per section) protect Records, Staff Docs, Licensing, and Billing</li>
          <li>Bcrypt-hashed passwords; never stored in plain text</li>
          <li>Daily database backups with point-in-time recovery</li>
          <li>Role-based access (owner / admin / staff / parent) — staff cannot see billing, parents cannot see other families</li>
        </ul>

        <h2>5. Children's privacy</h2>
        <p>Although ChildCheckOh stores information about minors, it is provided to us by the licensed childcare center on behalf of the parent/guardian who signed enrollment documents. We do not market to children, and children do not interact directly with our Service.</p>

        <h2>6. Your rights</h2>
        <ul>
          <li><b>Access:</b> View all data we have about your center from your dashboard</li>
          <li><b>Correct:</b> Edit any record directly</li>
          <li><b>Export:</b> Download a copy of your data any time</li>
          <li><b>Delete:</b> Email <a href="mailto:support@childcheckoh.com">support@childcheckoh.com</a> to request deletion — we&apos;ll remove your data within 30 days unless required by Ohio law to retain it longer (e.g., licensing records)</li>
        </ul>

        <h2>7. Cookies</h2>
        <p>We use a single session cookie for authentication and a vault session token in sessionStorage. We do NOT use third-party advertising cookies or tracking pixels.</p>

        <h2>8. Data retention</h2>
        <p>We retain your data for as long as your subscription is active plus 30 days after cancellation, so you can re-activate without losing history. After 30 days you can request permanent deletion.</p>

        <h2>9. International transfers</h2>
        <p>Your data is stored on US-based servers. If you access the Service from outside the US, you consent to the transfer and processing of your data in the US.</p>

        <h2>10. Changes to this policy</h2>
        <p>We may update this Privacy Policy. Material changes will be emailed to your owner address with at least 30 days' notice.</p>

        <h2>11. Contact</h2>
        <p>Privacy questions: <a href="mailto:info@childcheckoh.com">info@childcheckoh.com</a></p>
      </main>
      <Footer />
    </div>
  );
}
